import { Tabs } from "@rothoblaas/design-system";
import { FC } from "react";
import useI18n from "../../../../hooks/useTranslations";
import { ModuleSettings } from "../../../../http/types/modules";
import CondCategoriesTab from "./CondCategoriesTab";
import ExamplesTab from "./ExamplesTab";
import MaterialCategoriesTab from "./MaterialCategoriesTab";
import MaterialsTab from "./MaterialsTab";
import MaterialSubcategoriesTab from "./MaterialSubcategoriesTab";

// The module's visibility is configured by the module page itself (as for the other engines since main's change).
const EnvelopeDesignerAdminSettings: FC<{ moduleData: ModuleSettings }> = () => {
  const i18n = useI18n();
  const t = i18n.translation.envelopeDesignerModule.admin;

  return (
    <Tabs
      urlParameter="l_tab"
      tabs={[
        { title: t.materials },
        { title: t.categories },
        { title: t.subcategories },
        { title: t.condCategories },
        { title: t.examples },
      ]}
      contents={[
        <MaterialsTab />,
        <MaterialCategoriesTab />,
        <MaterialSubcategoriesTab />,
        <CondCategoriesTab />,
        <ExamplesTab />,
      ]}
    />
  );
};

export default EnvelopeDesignerAdminSettings;
